import axios from "axios";
import { ShipmentType } from "models/shipping";
import { useAuthenticatedRequestCreator } from "./useRequests";

export type CreationResult = {
    successful: boolean;
    message: string;
}

const useShipmentCreation = () => {
    const enqueueShipmentCreation = useAuthenticatedRequestCreator<CreationResult, ShipmentType[]>(
        (shipmentTypes) => ({
            method: "post",
            url: "/shipping/create-shipments",
            data: {
                shipmentTypes
            }
        }), [409, 403]
    );

    const createShipments = async (shipmentTypes: ShipmentType[] = []): Promise<CreationResult> => {
        try {
            await enqueueShipmentCreation(shipmentTypes);
            return { successful: true, message: "Shipment creation in progress!" };
        } catch (e: any) {
            const resp = { successful: false };

            if (axios.isAxiosError(e)) {
                if (e.response?.status === 409) {
                    return { ...resp, message: "Shipment creation is already in progress" }
                } else if (e.response?.status === 403) {
                    return { ...resp, message: "Shipment creation has been disabled" };
                }
            }

            return { ...resp, message: "Shipment creation failed!" }
        }
    }

    return { createShipments };
}

export default useShipmentCreation;